import React from "react"
import {
  ReactUseState,
  IsSearchingContext,
  GridInitializedContext,
  IsRestoreSearchingContext,
  IsPromptRefContext,
} from "../../../components/Context"
import { T海コン検索日種別コード } from "../../../constant/enum/frontend"
import {
  TKaikonZyutyuHaisyaListGetReq,
  TKaikonZyutyuHaisyaListGetRes,
} from "../../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"

// TODO:API確定後、responseの型に変更
export const SearchResultContext = React.createContext<
  TKaikonZyutyuHaisyaListGetRes[] | undefined
>([])

export const SearchMethodContext = React.createContext<
  (
    searchCondition?: TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>
  ) => unknown
>(() => {})

export const SearchConditionContext = React.createContext<
  TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード> | undefined
>({} as TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>)

export const ZyutyubusyoContext = React.createContext<string>("")

/**
 * 海コン受注配車入力のProvider
 */
export const KaikonZyutyuHaisyaListProvider: React.FC<{
  isSearching: ReactUseState<boolean>
  isRestoreSearching: ReactUseState<boolean>
  gridInitialized: ReactUseState<boolean>
  SearchResult: Array<TKaikonZyutyuHaisyaListGetRes> | undefined
  searchCondition:
    | TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>
    | undefined
  search: (
    searchCondition?: TKaikonZyutyuHaisyaListGetReq<T海コン検索日種別コード>
  ) => unknown
  受注部所コード: string
  isPrompt: React.MutableRefObject<boolean>
}> = (props) => {
  return (
    <IsSearchingContext.Provider value={props.isSearching}>
      <SearchResultContext.Provider value={props.SearchResult}>
        <GridInitializedContext.Provider value={props.gridInitialized}>
          <IsRestoreSearchingContext.Provider value={props.isRestoreSearching}>
            <SearchConditionContext.Provider value={props.searchCondition}>
              <SearchMethodContext.Provider value={props.search}>
                <ZyutyubusyoContext.Provider value={props.受注部所コード}>
                  <IsPromptRefContext.Provider value={props.isPrompt}>
                    {props.children}
                  </IsPromptRefContext.Provider>
                </ZyutyubusyoContext.Provider>
              </SearchMethodContext.Provider>
            </SearchConditionContext.Provider>
          </IsRestoreSearchingContext.Provider>
        </GridInitializedContext.Provider>
      </SearchResultContext.Provider>
    </IsSearchingContext.Provider>
  )
}
